import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import StyledButton from "../../Components/StyledButton";

const DesignerBox = styled(Box)({
  height: "100vh",
  width: "100vw",
  background: "#9acef8",
  display: "flex",
  justifyContent: "center",
});

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <DesignerBox>
      <Typography
        variant="h3"
        sx={{
          position: "absolute",
          top: 20,
        }}
      >
        Tic Tac Toe
      </Typography>

      <Typography
        variant="h6"
        sx={{
          position: "absolute",
          top: 250,
        }}
      >
        You know the rules and so do I..
      </Typography>

      <Typography
        variant="p"
        sx={{
          position: "absolute",
          top: 280,
        }}
      >
        -Rick Astley
      </Typography>

      <StyledButton
        onClick={() => {
          const rn = new Date();
          navigate(`/game/${rn.getTime()}`);
        }}
        sx={{
          top: 500,
          height: 40,
          outline: "2px solid #335c67",
        }}
      >
        Start Game
      </StyledButton>
    </DesignerBox>
  );
};

export default LandingPage;
